<template>
    <div class="p-20px">
        <div class="flex justify-between items-center">
            <div class="w-28px h-28px flex items-center justify-center" @click="handleBack">
                <img src="@/assets/images/mine/left.webp" class="w-full h-full" />
            </div>
            <div class="text-18px font-800">
                {{ title }}
            </div>
            <div class="w-20px"></div>
        </div>
        <div class="flex flex-wrap gap-10px mt-20px">
            <div v-for="value in source" :key="value.id" class="">
                <div class="w-110px h-160px overflow-hidden rounded-10px">
                    <img :src="value.avatar" class="w-100% h-100% object-cover" />
                </div>
                <div class="text-14px font-800 mt-10px">
                    {{ value.name }}
                </div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { HomeAPI } from '@/services/home';
import { onMounted, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
const route = useRoute()
const router = useRouter()
const title = route.query.name as string
const source = ref<any[]>([])
const getRoleListByPlate = async () => {
    const res = await HomeAPI.getRoleListByPlate({ plateId: Number(route.query.plateId) })
    source.value = res.data
}

const handleBack = () => {
    router.back()
}

onMounted(() => {
    getRoleListByPlate()
})
</script>